export interface CallUraModel {
    node: string;
    digit: string;
}
